$(document).ready(function () {
    const SITE_MSG_SPEED = 27; // px/s

    const buildSiteMsgMarquee = function () {
        const $siteMsgText = $(".site-msg.information").first().find(".text");
        const $siteMsgMovable = $siteMsgText.find(".movable");
        if (!$siteMsgMovable.length) return;

        // jQuery .css() neumí CSS custom properties — nutno přes nativní style API
        const movableEl = $siteMsgMovable[0];

        $siteMsgMovable.find("span.site-msg-clone").remove();
        $siteMsgText.removeClass("js-marquee");
        movableEl.style.removeProperty("--marquee-duration");

        const $originals = $siteMsgMovable.children("span").not(".site-msg-clone");
        if (!$originals.length) return;

        $siteMsgText.addClass("js-marquee");

        const containerWidth = $siteMsgText.outerWidth();

        let setWidth = 0;
        $originals.each(function () {
            setWidth += $(this).outerWidth(true);
        });
        if (setWidth <= 0) return;

        while (setWidth < containerWidth) {
            $originals.each(function () {
                $(this).clone().addClass("site-msg-clone").appendTo($siteMsgMovable);
            });
            setWidth *= 2;
        }

        $siteMsgMovable.children("span").clone().addClass("site-msg-clone").appendTo($siteMsgMovable);

        movableEl.style.setProperty("--marquee-duration", (setWidth / SITE_MSG_SPEED) + "s");
    };

    setTimeout(buildSiteMsgMarquee, 0);

    let siteMsgResizeTimer;
    $(window).on("resize", function () {
        clearTimeout(siteMsgResizeTimer);
        siteMsgResizeTimer = setTimeout(buildSiteMsgMarquee, 150);
    });
})